import { sortBy } from 'lodash';

import React from 'react';

import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphPlotband,
  GraphInstanceProps
} from '../index';
import { FormatDate } from '../../../../libs/time';
import {
  IEpxDiabetes,
  IEpxDiabetesSettings
} from '../../../../libs/apps/epxdiabetes';
import { CHART } from '../../../../config/colors';

const EpxDiabetesGraphs: React.FC<GraphInstanceProps> = (
  props
): JSX.Element => {
  const graph: GraphBlueprint<IEpxDiabetes, IEpxDiabetesSettings> = {
    name: 'Blood Sugar Graph',
    config: {
      chart: {
        type: 'line'
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: {
        title: {
          text: 'Blood Sugar (mg/dL)'
        }
      },
      responsive: {}
    },
    draw: (sessions, currentOptions, settings) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries = {
        type: 'line',
        name: 'Glucose Level',
        connectNulls: true
      };
      const data: GraphPoint[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        const time = session.respondedAt || session.time;
        let { bloodSugar } = session;
        let color: string = null;
        // Do a sanity check
        if (!(0 <= bloodSugar && bloodSugar <= 1500)) {
          bloodSugar = null;
        } else if (bloodSugar > 200 || bloodSugar < 70) {
          color = CHART.DANGER;
        } else if (bloodSugar > 130) {
          color = CHART.WARNING;
        } else {
          color = CHART.NORMAL;
        }
        data.push({
          x: i,
          y: bloodSugar,
          name: FormatDate(time, 'MM/DD'),
          marker: {
            fillColor: color,
            lineColor: color,
            lineWidth: 2
          }
        });
      }
      series.data = data;
      options.series = [series];
      const plotBands: GraphPlotband[] = [];
      if (settings?.thresholds?.red?.fasting?.min >= 0) {
        plotBands.push({
          from: 0,
          to: settings.thresholds?.red.fasting.min,
          color: CHART.PLOT_BAND_DANGER
        });
      }
      if (settings?.thresholds?.red?.fasting?.max >= 0) {
        plotBands.push({
          from: settings.thresholds?.red.fasting.max,
          to: 10000,
          color: CHART.PLOT_BAND_DANGER
        });
      }
      options.yAxis = {
        ...currentOptions.yAxis,
        plotBands: plotBands
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxDiabetes>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxDiabetesGraphs;
